export default __webpack_public_path__ + "assets/santa-luzia-component.9140f8ee.svg";